import { Fragment, useMemo, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

import { useEditor } from '@craftjs/core'
import { List, ListItem } from 'twyne-new.ui'

import Sidebar from '../../Sidebar'
import { TailwindSandboxPure } from '../../TailwindSandbox'

export default function VariantAssetItem({ item, floatbarRef }) {
  const [open, setOpen] = useState(false)
  const { element, icon, text, variants } = item
  const { connectors: { create }, actions: { setProp } } = useEditor()

  const handleOpen = useMemo(() => {
    let timeoutId = null

    return open => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      if (open) {
        setOpen(true)
      } else {
        timeoutId = setTimeout(() => setOpen(false), 100)
      }
    }
  }, [])

  const handleCreateVariant = propsRef => ref => create(ref, element, {
    onCreate: ({ rootNodeId }) => {
      setProp(rootNodeId, prop => {
        Object.assign(prop.properties, propsRef.current)
      })
    },
  })

  return <ListItem
    className={open ? 'w-100' : ''}
    onMouseEnter={() => handleOpen(true)}
    onMouseLeave={() => handleOpen(false)}
    value={<div className='flex items-center gap-2'>
      {icon}
      {text}
      {floatbarRef.current && createPortal(
        <Sidebar open={open} className='absolute inset-0 h-full z-50 shadow-lg' size='96'>
          <div className='h-[142em]'>
            <TailwindSandboxPure>
              <List className='flex flex-col gap-y-4'>
                {variants.map(data => <VariantPreview
                  key={data.key}
                  data={data}
                  onDragStart={() => handleOpen(false)}
                  onCreate={handleCreateVariant}
                />)}
              </List>
            </TailwindSandboxPure>
          </div>
        </Sidebar>,
        floatbarRef.current,
      )}
    </div>}
  />
}

function VariantPreview({ data: { key, label, preview: Preview, props: defaultProps, LabelTag = Fragment }, onDragStart, onCreate }) {
  const propsRef = useRef(defaultProps)

  return <ListItem
    className='border border-gray-300 dark:border-gray-400 rounded-xs'
    value={<LabelTag {...(LabelTag !== Fragment ? { label } : {})}>
      <div onDragStart={onDragStart} ref={onCreate(propsRef)} className='w-full'>
        <Preview {...defaultProps} label={label} variant={key} onChangeProps={props => {
          propsRef.current = { ...defaultProps, ...props }
        }}>{label}</Preview>
      </div>
    </LabelTag>}
  />
}

